<template>
  <div
    class="city-panel__result"
    role="option"
    tabindex="-1"
    :aria-selected="active"
    :class="{ 'is-active': active }"
    @click="onSelect"
    @keydown.enter.prevent="onSelect"
    @mousemove="onActivate"
  >
    <span class="city-panel__result-text">
      <span class="city-panel__result-name">
        <span
          v-for="(part, index) in parts"
          :key="index"
          :class="{ 'city-panel__mark': part.match }"
          >{{ part.text }}</span
        >
      </span>
      <span class="city-panel__result-meta" v-text="meta" />
    </span>
    <svg aria-hidden="true" class="icon"><use href="#chevron-right" /></svg>
  </div>
</template>

<script>
  import { highlightMatch } from "Library/highlightMatch";
  import { sprintf } from "sprintf-js";

  export default {
    computed: {
      /** "Stockholms län · 4 services", dropping either half when unknown. */
      meta() {
        const parts = [];

        if (this.city.region) {
          parts.push(this.city.region);
        }

        if (this.city.services) {
          const template =
            this.city.services === 1
              ? this.texts.servicesSingular
              : this.texts.servicesPlural;
          parts.push(sprintf(template, this.city.services));
        }

        return parts.join(" · ");
      },

      parts() {
        return highlightMatch(this.city.label, this.query);
      },
    },

    data() {
      return {
        texts: theme_vars.cityCaseTypeSelect,
      };
    },

    emits: ["select", "activate"],

    methods: {
      onActivate() {
        this.$emit("activate", this.position);
      },

      onSelect() {
        this.$emit("select", this.city);
      },
    },
    name: "CityPanelResult",

    props: {
      active: {
        default: false,
        type: Boolean,
      },
      city: {
        required: true,
        type: Object,
      },
      /** Index in the result list, so the parent can track the active row. */
      position: {
        required: true,
        type: Number,
      },
      /** What the visitor typed, marked inside the city name. */
      query: {
        default: "",
        type: String,
      },
    },
  };
</script>
